<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"

  /**
   * @type {Array} list of font family names
   */
  export let dropdownItems
  /**
   * @type {String} the default or active font family in the dropdown area
   */
  export let activeItem
  /**
   * @type {HTMLElement} binded the overall dropdown parent element
   */
  let dropdown
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false
  /**
   * @type {HTMLElement} Reference to the input element used for editing.
   */
  let editInput

  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    // Check if the event target is not within the dropdown
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="relative w-full" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    type="button"
    class="relative w-full rounded-md border border-stone-700 bg-transparent text-sm font-bold text-gray-g00 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    <div class="group flex items-center justify-between">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <input
        on:wheel|preventDefault|stopPropagation={(e) => {
          if (e.deltaY < 0) {
            activeItem++
          } else {
            if (activeItem > 0) {
              activeItem--
            }
          }
        }}
        on:keypress={(e) => {
          if (e.key == "-" || e.key == "e" || e.key == "E" || e.key == "+") {
            e.preventDefault()
          }
        }}
        on:keydown={(e) => {
          if (e.key == "Delete") {
            e.stopPropagation()
          }
        }}
        on:click={() => {
          showDropdown = !showDropdown
          editInput.select()
        }}
        on:blur={() => {
          if (!activeItem) {
            $fileTemplateState.activeFontSize = activeItem = 40
          }
          $fileTemplateState.activeFontSize = activeItem
        }}
        bind:this={editInput}
        type="number"
        bind:value={activeItem}
        class="relative w-full rounded-md border border-stone-700 bg-transparent px-3 py-2 pr-8 text-sm font-bold text-white shadow-sm outline-none focus:text-blue-500 focus:ring-2 focus:ring-blue-500 group-focus-within:text-extraBlue-500"
      />

      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center group-focus-within:text-extraBlue-500">
        <i class="fa-solid fa-chevron-down" />
      </div>
    </div>
  </button>
  <ul style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute z-10 mt-2 max-h-40 w-full flex-col overflow-auto rounded-md border border-none bg-gray-f00 text-sm outline-none ring-2" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={() => {
          activeItem = item
          $fileTemplateState.activeFontSize = item
          showDropdown = false
        }}
        class="{activeItem == item ? 'bg-gray-e00 text-white' : ''} cursor-pointer select-none rounded-md bg-transparent py-2 pl-3 pr-9 text-sm font-bold text-gray-g00 hover:bg-gray-e00 hover:text-extraBlue-500"
      >
        {item}
      </li>
    {/each}
  </ul>
</div>
